const filterDelimiters = {
    filter: ';',
    definition: ':',
    values: ',',
    range: '..',
};

export default filterDelimiters;
